import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/mixpanel"

// Builder pricing page + offer (Phelipe 2026-10-30): the Monthly / Yearly
// switch. Shows the matching prices, marks the chosen button and writes the
// interval into every checkout form on the page. Clicking a plan card
// highlights it (2026-10-31).
export default class extends Controller {
  static targets = ["toggle", "monthly", "yearly", "intervalField", "card"]
  static values = { interval: { type: String, default: "month" } }

  connect() {
    this._apply()
  }

  monthly() {
    this.intervalValue = "month"
  }

  yearly() {
    this.intervalValue = "year"
  }

  intervalValueChanged() {
    this._apply()
  }

  select(event) {
    const card = event.currentTarget
    if (card.dataset.selected === "true") return

    this.cardTargets.forEach((el) => { el.dataset.selected = el === card ? "true" : "false" })
    track("Pricing Plan Selected", { plan: card.dataset.plan, interval: this.intervalValue })
  }

  _apply() {
    const yearly = this.intervalValue === "year"
    this.monthlyTargets.forEach((el) => el.classList.toggle("hidden", yearly))
    this.yearlyTargets.forEach((el) => el.classList.toggle("hidden", !yearly))
    this.intervalFieldTargets.forEach((input) => { input.value = this.intervalValue })
    this.toggleTargets.forEach((button) => {
      const on = button.dataset.interval === this.intervalValue
      button.dataset.selected = on ? "true" : "false"
      button.setAttribute("aria-pressed", on ? "true" : "false")
    })
  }
}
